import React from 'react';
import { useThemeContext } from "../../context/themeContext";

const Card06 = ({ image, direction }) => {

    const { themeSetting } = useThemeContext()

    const wrapperStyle = {
        position: 'relative',
        display: 'flex',
        justifyContent: direction == "right" ? 'end' : 'start',
        width: '100%',
        paddingBottom: '90%'
    }

    const style = {
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: '100 0px',
        position: 'absolute',
        top: '30px',
        left: '30px',
        width: '90%',
        height: '90%'
    };

    const borderStyle1 = {
        position: "absolute",
        width: '85%',
        height: '85%',
        borderRadius: '100px 0', 
        border: '4px solid transparent', 
        background: `linear-gradient(180deg, ${themeSetting.colors.primary}, transparent) border-box`,
        WebkitMask: 'linear-gradient(#fff 0 0) padding-box,' + 'linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor', /*5'*/
        maskComposite: 'exclude',
        left: direction == 'right' && 0,
        right: direction == 'left' && 0,
        transform: direction == 'left' && 'scaleY(-1) rotate(180deg)'
    }
    
    const borderStyle2 = {
        position: "absolute",
        width: '85%',
        height: '85%',
        borderRadius: '100px 0', 
        border: '4px solid transparent', 
        background: `linear-gradient(180deg, ${themeSetting.colors.secondary}, transparent) border-box`,
        WebkitMask: 'linear-gradient(#fff 0 0) padding-box,' + 'linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor', /*5'*/
        maskComposite: 'exclude',
        bottom: 0,
        right: 0,
        left: direction == 'left' && 0,
        transform: direction == 'left' && 'scaleY(-1) rotate(180deg)'
    };

    return (
        <div style={wrapperStyle}>
            <div style={borderStyle1}></div>
            <div style={borderStyle2}></div>
            <img src={image} style={style} alt='luncguardian' />
        </div>
    );
};

export default Card06;